module.exports = __webpack_public_path__ + "img/vertical_4_7_8003.57eaeb90.png";